module.exports = __webpack_public_path__ + "static/media/ma.a31fa394.svg";